import { Colors } from "@zapier/design-system";

export function IconInterfacesNavLogo({
  size = 24,
  color = Colors.brand,
}: {
  size?: number;
  color?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="26" height="26" rx="4" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 10.1108V23.1108L16.9393 19.7807L17.1516 19.6192L23.8333 19.6287L13 10.1108Z"
        fill="#FFFDF9"
      />
      <rect
        x="3.61102"
        y="3.61084"
        width="2.16667"
        height="2.16667"
        fill="#FFFDF9"
      />
      <rect
        x="7.94458"
        y="3.61084"
        width="14.4444"
        height="2.16667"
        fill="#FFFDF9"
      />
    </svg>
  );
}
